import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IcosRate } from './rate'


@NgModule({
  declarations: [IcosRate],
  exports: [IcosRate],
  imports: [CommonModule],
  entryComponents: [IcosRate],
})
export class IcosRateModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosRateModule, providers: [] }
  }
}
